"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestHandler = void 0;
/**
 * Implemented by classes used to process incoming streaming requests sent over an [IStreamingTransport](xref:botframework-streaming.IStreamingTransport).
 */
var RequestHandler = /** @class */ (function () {
    function RequestHandler() {
    }
    return RequestHandler;
}());
exports.RequestHandler = RequestHandler;
//# sourceMappingURL=requestHandler.js.map